import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { GraduationCap } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin" : u.intake_complete ? "/dashboard" : "/intake");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0A192F] p-12 text-white">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-white/10 flex items-center justify-center"><GraduationCap className="h-5 w-5 text-amber-500" /></div>
          <span className="font-heading font-bold">Insurance License Lab</span>
        </Link>
        <div>
          <h1 className="font-heading text-4xl font-extrabold leading-tight">Study Smarter.<br /><span className="text-amber-500">Get Licensed.</span></h1>
          <p className="mt-4 text-slate-300 max-w-sm">Pick up right where you left off — your workbook, audio, and quiz progress are waiting.</p>
        </div>
        <p className="text-xs text-slate-500 font-mono">CALIFORNIA · PROPERTY &amp; CASUALTY</p>
      </div>

      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8 flex items-center gap-2">
            <div className="h-9 w-9 rounded-lg bg-[#0A192F] flex items-center justify-center"><GraduationCap className="h-5 w-5 text-amber-500" /></div>
            <span className="font-heading font-bold text-[#0A192F]">Insurance License Lab</span>
          </div>
          <h2 className="font-heading text-2xl font-bold text-[#0A192F]">Log in to your account</h2>
          <p className="text-sm text-slate-500 mt-1">Enter your details below</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="login-email-input" />
            </div>
            <div>
            <div className="flex items-center justify-between">
              <Label htmlFor="password">Password</Label>
              <Link to="/forgot-password" className="text-sm text-amber-600 font-medium" data-testid="login-forgot-link">Forgot password?</Link>
            </div>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="login-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-amber-600 hover:bg-amber-700 text-white h-11" data-testid="login-submit-btn">
              {loading ? "Logging in…" : "Log in"}
            </Button>
          </form>
          <p className="text-sm text-slate-500 mt-6 text-center">
            No account? <Link to="/register" className="text-amber-600 font-semibold">Create one free</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
